/**
 * data:{key,fn,params,urlParams}
 * key,调用的接口
 * fn当前页面调用的方法，刷新token后重新调用
 * params,参数
 * urlParams,url后的参数
 * **/
import router from '../../router';
import store from '../../store'
import api from '../../api/api'
import { Message } from 'element-ui';

function UnifiedApi(data){
    let fn = data.fn;
    return data.api(data.params,data.urlParams).catch(async function(err){
        //接口返回token失效的err信息的指定状态码
        if(err.status === 302){
            //获取全局是否在刷新登录token
            let refresh = store.state.refresh;
            if(refresh){
                //如果正在刷新，则轮询，直到刷新完成后，继续执行
                let aaa = setInterval(function(){
                    let refresh = store.state.refresh;
                    if(!refresh){
                        clearInterval(aaa);
                        fn();
                    }
                },500);
            }else{
                store.state.refresh = true;
                //否则继续
                let token = localStorage.getItem('cashier-pc-v2-refreshToken');
                let redirectUrl = window.location.pathname.slice(11)+window.location.search;
                if(token){
                    localStorage.setItem('cashier-pc-v2-token',token);
                    let e = await api.refreshToken().catch(function(){
                        localStorage.clear();
                        Message.error('登录状态失效，请重新登录');
                        store.state.refresh = false;
                        router.replace({path: '/login',query:{redirectUrl:encodeURI(redirectUrl)}});
                        return false;
                    });
                    if(!e || !e.data) return;
                    if(e.data.respCode === '0000'){
                        let data = JSON.parse(e.headers.token),
                            token = data.access_token,        //登录token
                            refreshToken = data.refresh_token;//刷新token
                        localStorage.setItem('cashier-pc-v2-token', token);
                        localStorage.setItem('cashier-pc-v2-refreshToken', refreshToken);
                        fn()
                    }else{
                        localStorage.clear();
                        Message.error(e.data.respInfo);
                        router.replace({path: '/login',query:{redirectUrl:encodeURI(redirectUrl)}});
                    }
                    store.state.refresh = false;
                }else{
                    localStorage.clear();
                    Message.error('登录状态失效，请重新登录');
                    store.state.refresh = false;
                    router.replace({path: '/login',query:{redirectUrl:encodeURI(redirectUrl)}});
                }
            }
        }
    });
}


export default UnifiedApi